import { FirebaseDataService } from '@app/shared/services/firebase-data.service';
import { CommonService } from '@app/shared/services/common.service';
import { Pipe, PipeTransform } from '@angular/core';
import { IndianNumberPipe } from './indian-numbering-style.pipe';

@Pipe({
    name: 'covrtcurrency',
    standalone: false
})
export class CurrencyConversionPipe implements PipeTransform {
  private indianNumberPipe: IndianNumberPipe = new IndianNumberPipe();
  constructor(
    private fbDatabase: FirebaseDataService,
    private commonService: CommonService
  ) {}
  public transform(value: any, type: string, pageType?: any, flag?: boolean, useIndianFormat?: boolean) {
    if (
      value == null ||
      Number(value) == 0 ||
      value == null ||
      !this.commonService.userCurrency ||
      this.commonService.userCurrency.currencyId == 'USD' ||
      !this.fbDatabase.currencyPrices[
        this.commonService.userCurrency.currencyId
      ] ||
      value == '.'
    ) {
      return '';
    } else {
      let price = '';
      if (type == 'user') {
        if (
          this.fbDatabase.currencyPrices[
            this.commonService.userCurrency.currencyId
          ]
        ) {
          const obj = {
            currencyPrice:
              this.fbDatabase.currencyPrices[
                this.commonService.userCurrency.currencyId
              ],
            currencyCode: this.commonService.userCurrency.currencyId,
          };
          for (const p in obj) {
            if (obj.hasOwnProperty(p)) {
              let z = String(
                (
                  value *
                  this.fbDatabase.currencyPrices[
                    this.commonService.userCurrency.currencyId
                  ]
                ).toLocaleString('en', {
                  useGrouping: false,
                })
              );
              let storecurrValue;
              if (pageType != 'updateCurrency') {
                z = z.indexOf('.') != -1 ? z.slice(0, z.indexOf('.') + 3) : z;
                storecurrValue = Math.round(Number(z)).toLocaleString('en', {
                  useGrouping: false,
                });
              } else {
                z =
                  z.indexOf('.') != -1 && z.indexOf('.') != 1
                    ? z.slice(0, z.indexOf('.') + 3)
                    : z;
                storecurrValue = Math.round(Number(z));
              }
              let formattedValue = storecurrValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              if (useIndianFormat) {
                formattedValue = this.indianNumberPipe.transform(Number(storecurrValue));
              }

              const cPrice = {
                currPrice: formattedValue,
                currCode: ' ' + this.commonService.userCurrency.currencyId,
              };
              price = cPrice.currPrice + cPrice.currCode;
            }
          }
        } else {
          price = '';
        }
      } else if (type == 'rounded') {
        if (
          this.fbDatabase.currencyPrices[
            this.commonService.userCurrency.currencyId
          ]
        ) {
          let convertedValue = String(
            (
              Number(value) *
              (flag == true ? (Math.floor(this.fbDatabase.currencyPrices[
                this.commonService.userCurrency.currencyId
              ]*100)/100) : this.fbDatabase.currencyPrices[
                this.commonService.userCurrency.currencyId
              ])
            ).toFixed(0)
          ).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          if (useIndianFormat) {
            convertedValue = this.indianNumberPipe.transform(Number(convertedValue.replace(/,/g, '')));
          }
          price = convertedValue +
            ' ' +
            this.commonService.userCurrency.currencyId;
        } else {
          price = '';
        }
      } else if (type == 'round') {
        if (
          this.fbDatabase.currencyPrices[
            this.commonService.userCurrency.currencyId
          ]
        ) {
          let convertedValue = String(
            (
              Number(value) *
              this.fbDatabase.currencyPrices[
                this.commonService.userCurrency.currencyId
              ]
            ).toFixed(0)
          ).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          if (useIndianFormat) {
            convertedValue = this.indianNumberPipe.transform(Number(convertedValue.replace(/,/g, '')));
          }
          price = convertedValue +
            ' ' +
            this.commonService.userCurrency.currencyId;
        }
      }
      else if (type && pageType === 'USD') {
       const from = type.toUpperCase();   // e.g. INR, EUR,...
        const fromRate = this.fbDatabase.currencyPrices[from];
       if (fromRate) {
      const valueInUSD = Number(value) / fromRate;
       price = `${Math.round(valueInUSD)} USD`;
      } else {
      price = '';
     }
    }
      else if (
        type &&
        this.fbDatabase.currencyPrices?.[type.toUpperCase()]
      ) {
        const rate = this.fbDatabase.currencyPrices[type.toUpperCase()];
        const convertedValue = Number(value) * rate;
        const rounded = Math.round(convertedValue);
        let formatted = rounded.toString();
        if (useIndianFormat) {
          formatted = this.indianNumberPipe.transform(rounded);
        } else {
          formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        price = `${formatted} ${type.toUpperCase()}`;
      }  else {
        if (
          this.fbDatabase.currencyPrices[
            this.commonService.userCurrency.currencyId
          ]
        ) {
          let convertedValue = String(
            Number(value) /
              this.fbDatabase.currencyPrices[
                this.commonService.userCurrency.currencyId
              ]
          ).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          if (useIndianFormat) {
            convertedValue = this.indianNumberPipe.transform(Number(convertedValue.replace(/,/g, '')));
          }
          price = convertedValue + ' USD';
        } else {
          price = '';
        }
      }
      return price;
    }
  }
}
